var _rect, _circle, _path, _path2, _path3, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 384,
    fill: "#4AD4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896.001 512C896.001 738.6 432.001 738.6 432.001 512C432.001 299.923 512.001 128 512.001 128C608.432 128 696.561 163.545 764.001 222.248C844.879 292.648 896.001 396.354 896.001 512Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M896 512C896 552.43 889.752 591.401 878.168 628C866.585 664.599 813 722.5 714 722.5C744 628 864.208 342.502 764 222.248C844.878 292.648 896 396.354 896 512Z",
    fill: "#FFC01E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 512C505 720 764 801.752 764 801.752C696.56 860.455 608.431 896 512 896C299.923 896 128 724.077 128 512C128 299.923 299.923 128 512 128C608.431 128 696.56 163.545 764 222.248C764 222.248 519 304 512 512Z",
    fill: "#FF1D6F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 360,
    r: 50,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.16bf0f352805e80cbea8db32a3171203.svg";
export { ForwardRef as ReactComponent };